import { savingsOverviewNb } from '@apps/savings-overview/translations/nb';
import { fundListNb } from '@fund-list/translations/nb';
import { commonNb } from '@shared/translations/common/nb';
import { fundGuideNb } from '@shared/translations/fund-guide/nb';
import { transferShareSavingsAccountFormNb } from '@transfer-share-savings-account/translations/nb';
export const nbTranslations = {
    ...commonNb,
    ...fundGuideNb,
    ...fundListNb,
    ...savingsOverviewNb,
    ...transferShareSavingsAccountFormNb,
    errors: {
        ...commonNb.errors,
        ...fundListNb.errors,
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibmItdHJhbnNsYXRpb25zLWNvbmZpZy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy90cmFuc2xhdGlvbnMvbmItdHJhbnNsYXRpb25zLWNvbmZpZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsaUJBQWlCLEVBQUUsTUFBTSx3Q0FBd0MsQ0FBQztBQUMzRSxPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0sNEJBQTRCLENBQUM7QUFDeEQsT0FBTyxFQUFFLFFBQVEsRUFBRSxNQUFNLGdDQUFnQyxDQUFDO0FBQzFELE9BQU8sRUFBRSxXQUFXLEVBQUUsTUFBTSxvQ0FBb0MsQ0FBQztBQUNqRSxPQUFPLEVBQUUsaUNBQWlDLEVBQUUsTUFBTSxpREFBaUQsQ0FBQztBQUlwRyxNQUFNLENBQUMsTUFBTSxjQUFjLEdBQTJCO0lBQ2xELEdBQUcsUUFBUTtJQUNYLEdBQUcsV0FBVztJQUNkLEdBQUcsVUFBVTtJQUNiLEdBQUcsaUJBQWlCO0lBQ3BCLEdBQUcsaUNBQWlDO0lBQ3BDLE1BQU0sRUFBRTtRQUNKLEdBQUcsUUFBUSxDQUFDLE1BQU07UUFDbEIsR0FBRyxVQUFVLENBQUMsTUFBTTtLQUN2QjtDQUNKLENBQUMifQ==